<template>
    <div class="legal-landing">
        <h1>{{trans.get("legal.limitationOfLiability.title")}}</h1>
        <h3>
           {{trans.get("legal.limitationOfLiability.subtitle1.part1")}}
            <a href="https://www.humboldtseedcompany.es"
                >www.humboldtseedcompany.es</a
            >
            {{trans.get("legal.limitationOfLiability.subtitle1.part2")}}
        </h3>
        <p>{{trans.get("legal.limitationOfLiability.text1")}}</p>
        <p v-html="trans.get('legal.limitationOfLiability.text2')"></p>
        <p>{{trans.get("legal.limitationOfLiability.text3")}}
            <a href="https://www.humboldtseedcompany.es"
                >www.humboldtseedcompany.es</a> {{trans.get("legal.limitationOfLiability.text4")}}
        </p>
        <p v-html="trans.get('legal.limitationOfLiability.text5')"></p>
        <p>{{trans.get("legal.limitationOfLiability.text6")}}</p>
    </div>
</template>

<script>
export default {};
</script>
